import {
  IonRow,
  IonCol,
  IonContent,
  IonHeader,
  IonPage,
  IonToolbar,
  IonButton,
  IonIcon,
  IonCard,
  IonCardContent,
} from '@ionic/react';

import {
  personCircleOutline,
  cubeOutline,
  calendarOutline,
  chevronForwardOutline,
  heartOutline,
  sparklesOutline,
} from 'ionicons/icons';

import './Advisor.css';

const Advisor: React.FC = () => {
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
              padding: '0 12px',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <img
                src="/assets/pl_icon/icon_nf_matt.png"
                alt="Pawer Lifting"
                style={{ height: 50, width: 'auto', display: 'block' }}
              />
              <strong>Muscle Advisor</strong>
            </div>

            <IonButton
              shape="round"
              fill="clear"
              aria-label="Account"
              routerLink="/my/settings"
            >
              <IonIcon icon={personCircleOutline} slot="icon-only" />
            </IonButton>
          </div>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen className="advisor-content">
        <section className="advisor-beta" aria-label="Premium beta information">
          <div className="advisor-beta__icon">
            <IonIcon icon={sparklesOutline} />
          </div>
          <div className="advisor-beta__copy">
            <span>Premium beta</span>
            <h2>Unlocked for beta testers</h2>
            <p>You have early access while we shape this feature together.</p>
          </div>
          <div className="advisor-beta__impact">
            <IonIcon icon={heartOutline} />
            <span>
              <strong>Help for animals</strong>When subscriptions launch, a
              percentage of the price will support an animal shelter in Germany.
            </span>
          </div>
        </section>
        <section
          className="advisor-intro"
          aria-labelledby="advisor-intro-title"
        >
          <img
            src="/assets/ploppy/ploppy-advisor-reading-noglasses.png"
            alt="Ploppy reading"
          />
          <div>
            <span>Your training helper</span>
            <h1 id="advisor-intro-title">Train with more context</h1>
            <p>
              Explore exercises, understand which muscles they target, and keep
              your cycle and wellbeing notes together.
            </p>
          </div>
        </section>

        <div className="advisor-section-heading">
          <span>Explore</span>
          <h2>Tools for your next workout</h2>
        </div>

        <IonRow className="advisor-tools">
          <IonCol>
            <IonCard
              className="advisor-tool"
              routerLink="/my/advisor/model"
              button
            >
              <IonCardContent>
                <div className="advisor-tool__icon" aria-hidden="true">
                  <IonIcon icon={cubeOutline} />
                </div>
                <div>
                  <span>Muscle map</span>
                  <h3>Explore the 3D model</h3>
                  <p>
                    Choose a body area and find exercises for those muscles.
                  </p>
                </div>
                <IonIcon
                  icon={chevronForwardOutline}
                  className="advisor-tool__arrow"
                  aria-hidden="true"
                />
              </IonCardContent>
            </IonCard>
          </IonCol>

          <IonCol>
            <IonCard className="advisor-tool" routerLink="/my/calendar" button>
              <IonCardContent>
                <div className="advisor-tool__icon" aria-hidden="true">
                  <IonIcon icon={calendarOutline} />
                </div>
                <div>
                  <span>Wellbeing log</span>
                  <h3>Mood &amp; cycle calendar</h3>
                  <p>Keep workout, mood, cycle, and personal notes together.</p>
                </div>
                <IonIcon
                  icon={chevronForwardOutline}
                  className="advisor-tool__arrow"
                  aria-hidden="true"
                />
              </IonCardContent>
            </IonCard>
          </IonCol>
        </IonRow>
      </IonContent>
    </IonPage>
  );
};

export default Advisor;
